import { useMsal } from '@azure/msal-react';
import { Button, IconButton, CircularProgress, Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, Accordion, AccordionSummary, AccordionDetails, Tooltip } from '@material-ui/core'
import { Error, CheckCircle, KeyboardArrowRight } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { ReactElement, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { globalStyles } from '../../assets/globalStyles';
import { useStyles } from './pqEreignisseStyles';
import {
    getPQEreignisseForMessstelle, getPQStatus, getMesswertuebersicht, selectPQMessstellenEreignisse, selectPQMessstellenStoerschriebe, selectPQMessstellenStatus, selectPQmessstellenereignisseLoading,
    selectStoerschriebeereignisseLoading, selectPQmessstellenstatusLoading, selectPQStatus, selectPQStatusLoading, selectZeitraum, setPQMessstellenEreignisse, setZeitraum, selectMessstellenFilter, selectEreignisseFilter, selectStoerschreibeFilter,
    setEreignisseFilter, setStoerschriebeFilter
} from './pqEreignisseSlice';
import { pqereignissemessstelle, pqstatusmessstelle, messwertLog } from '../../utils/apiTypes';
import { addTabNotResetDate, onDropDownSelect, updateField } from '../netzwirtschaft/netzwirtschaftSlice';
import { useHistory } from 'react-router';
import { logError, nanosecondsTimeStampToDate, nanosecondsTimeStampToLocalString, nanosecondsTimeStampToUTCString } from '../../utils/utils';
import { getWithAuth } from '../../utils/api';
import { messstelle } from './../../utils/apiTypes';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { getMessstellenForLookup, getMessstellenLookup, selectMessstellenLoadingLookup, selectMessstellenDictionary } from '../../features/messstellenLookup/messstellenLookupSlice';
import LegendeStoerung from '../../features/legende/legendeStoerung';
import { errorHandler } from '../../utils/errorHandling';
import CachedIcon from '@material-ui/icons/Cached';



export default function PQEreignisse(): ReactElement {
    const dispatch = useAppDispatch();
    const { instance } = useMsal();
    const [reload, setReload] = React.useState(false);


    useEffect(() => {
        dispatch(getPQStatus());
        dispatch(getMessstellenForLookup());
    }, [instance, reload]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const pqStatus = useAppSelector(selectPQStatus);
    const pqMessstellenStatus = useAppSelector(selectPQMessstellenStatus);
    const pqMessstellenEreignisse = useAppSelector(selectPQMessstellenEreignisse);
    const stoerschriebeEreignisse = useAppSelector(selectPQMessstellenStoerschriebe);

    const pqStatusLoading = useAppSelector(selectPQStatusLoading);
    const pqMessstellenStatusLoading = useAppSelector(selectPQmessstellenstatusLoading);
    const pqMessstellenEreignisseLoading = useAppSelector(selectPQmessstellenereignisseLoading);
    const stoerschriebeEreignisseLoading = useAppSelector(selectStoerschriebeereignisseLoading);
    const zeitraum = useAppSelector(selectZeitraum);
    const messstellenFilter = useAppSelector(selectMessstellenFilter);
    const ereignisseFilter = useAppSelector(selectEreignisseFilter);
    const stoerschriebeFilter = useAppSelector(selectStoerschreibeFilter);

    const messstellenDict = useAppSelector(selectMessstellenDictionary);
    const messstellenLoadingLookup = useAppSelector(selectMessstellenLoadingLookup);

    const isUTC = useAppSelector(selectDate);


    const keineGruppeTableCell = (label: string) => {

        return (
            <TableRow hover={true}>
                <TableCell />
                <TableCell
                    className={classes.tableHeadlineSub}
                    style={{ backgroundColor: "white", fontWeight: "600" }}
                    align="right" >
                    {label}
                </TableCell>
                <TableCell style={{ width: "30%" }} />
                <TableCell />
            </TableRow>
        );
    };

    const getIconForStateValue = (value: number) => {
        switch (value) {
            case 0:
                return (
                    <Tooltip title="Keine Störung" >
                        <CheckCircle style={{ color: "green" }} />
                    </Tooltip>)
            case 1:
                return (
                    <Tooltip title="Störung bei geplanten Ereignissen" >
                        <Error style={{ color: "green" }} />
                    </Tooltip>)
            case 2:
                return (
                    <Tooltip title="Punktereignis (kürzer 1 Sekunde" >
                        <Error style={{ color: "orange" }} />
                    </Tooltip>)
            case 3:
                return (
                    <Tooltip title="Abschnittsereignis (länger 1 Sekunde)" >
                        <Error className={classes.redSignalColor} />
                    </Tooltip>)
            default: return "";
        }
    }

    const getStateValueForZeitraum = (messstelle: pqstatusmessstelle, zeitraum: string) => {
        switch (zeitraum) {
            case "24h":
                return getIconForStateValue(messstelle.status24h);
            case "1M":
                return getIconForStateValue(messstelle.status1Month);
            case "12M":
                return getIconForStateValue(messstelle.status12Month);
        }
    }

    const getMessstellenForZeitraum = (messstellen: Array<pqstatusmessstelle>, zeitraum: string) => {
        const filteredMessstellen = messstellenFilter.length > 0 ? messstellen.filter(x => messstellenFilter.includes(x.messstelle)) : messstellen;
        switch (zeitraum) {
            case "24h":
                return filteredMessstellen.filter((e) => e.status24h !== 0);
            case "1M":
                return filteredMessstellen.filter((e) => e.status1Month !== 0);
            case "12M":
                return filteredMessstellen.filter((e) => e.status12Month !== 0);
            default:
                return filteredMessstellen;
        }
    }

    const [selectedMessstelle, setSelectedMessstelle] = React.useState("");
    const [pqmessstellenEreignisInputValue, setpqmessstellenEreignisInputValue] = React.useState('');
    const [pqmessstellenStoerschriebInputValue, setpqmessstellenStoerschriebInputValue] = React.useState('');

    const [expandedMesspunkt, setExpandedMesspunkt] = React.useState<boolean>(false);
    const [expandedEreignis, setExpandedEreignis] = React.useState<boolean>(false);
    const [expandedStoerschrieb, setExpandedStoerschrieb] = React.useState<boolean>(false);

    const history = useHistory();
    const linkToDetails = (tabName: string, messstelleS: string, start: number, ende: number, stoerschreib = false) => {
        getWithAuth("MESSSTELLEID", {}, messstelleS).then((messstelle: messstelle) => {
            dispatch(addTabNotResetDate(messstelle.name));
            dispatch(
                onDropDownSelect({
                    field: "uw",
                    value: messstelle.umspannwerk
                })
            );
            dispatch(
                onDropDownSelect({
                    field: "messpunkt",
                    value: messstelleS
                })
            );

            dispatch(
                updateField({
                    field: "startDatum",
                    value: nanosecondsTimeStampToDate(start)
                })
            );
            dispatch(
                updateField({
                    field: "endDatum",
                    value: nanosecondsTimeStampToDate(ende)
                })
            );
            if (stoerschreib) {
                switch (tabName) {
                    case "Oszilloskop (Störschriebe)":
                        dispatch(
                            onDropDownSelect({
                                field: "rekorder",
                                value: {
                                    klasse: "creca",
                                    kategorie: "Leistung und Energie",
                                    hersteller: "Eberle",
                                    beschreibung: "Oszilloskop (Störschriebe)",
                                    messstelle: messstelle.name
                                }
                            })
                        );
                        dispatch(updateField({
                            field: "messgroesse",
                            value: [
                                {
                                    beschreibung: 'u0E / uNE',
                                    feldname: 'oscu0',
                                    einheit: 'V',
                                    unterkategorie: null,
                                },
                                {
                                    beschreibung: 'u1E / u1N',
                                    feldname: 'oscu1',
                                    einheit: 'V',
                                    unterkategorie: null,
                                },
                                {
                                    beschreibung: 'u2E / u2N',
                                    feldname: 'oscu2',
                                    einheit: 'V',
                                    unterkategorie: null,
                                },
                                {
                                    beschreibung: 'u3E / u3N',
                                    feldname: 'oscu3',
                                    einheit: 'V',
                                    unterkategorie: null,
                                }
                            ]
                        }));
                        break;
                    default:
                        dispatch(
                            onDropDownSelect({
                                field: "rekorder",
                                value: {
                                    klasse: "crecb",
                                    kategorie: "Leistung und Energie",
                                    hersteller: "Eberle",
                                    beschreibung: "Effektivwerte (Störschriebe)",
                                    messstelle: messstelle.name
                                }
                            })
                        );
                        dispatch(updateField({
                            field: "messgroesse",
                            value: [
                                {
                                    beschreibung: 'u0E / uNE',
                                    feldname: 'halfcycleu0',
                                    einheit: 'V',
                                    unterkategorie: null,
                                },
                                {
                                    beschreibung: 'u1E / u1N',
                                    feldname: 'halfcycleu1',
                                    einheit: 'V',
                                    unterkategorie: null,
                                },
                                {
                                    beschreibung: 'u2E / u2N',
                                    feldname: 'halfcycleu2',
                                    einheit: 'V',
                                    unterkategorie: null,
                                },
                                {
                                    beschreibung: 'u3E / u3N',
                                    feldname: 'halfcycleu3',
                                    einheit: 'V',
                                    unterkategorie: null,
                                }
                            ]
                        }));
                }
            }
        }).catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        })
            .finally(() => history.push("/dashboardAnalyse"));
    }

    const onChangeZeitraum = (zeitraum: string) => {
        dispatch(setZeitraum(zeitraum));
        dispatch(setPQMessstellenEreignisse([]));
        setSelectedMessstelle("");
    }

    const getPQMesststellenListeWithoutDuplicate = (pqmessstelleListe: Array<pqereignissemessstelle>): string[] => {
        const pqmessstelleListeWithoutDuplicate = new Set(pqmessstelleListe.map(x => x.beschreibung + " " + x.typ + " " + x.harmonische));
        return Array.from(pqmessstelleListeWithoutDuplicate.values());
    }

    const getStoerschriebeListeWithoutDuplicate = (stoerschriebeListe: Array<messwertLog>): Array<string> => {
        const stoerschriebeWithoutDuplicate = new Set(stoerschriebeListe.map(x => x.datenklasse));
        return Array.from(stoerschriebeWithoutDuplicate.values());
    }

    const zeitraumSelect = [
        { value: "24h", name: "letzte 24 Stunden" },
        { value: "1M", name: "letzte 30 Tage" },
        { value: "12M", name: "letzte 12 Monate" },
    ]

    return (
        <Container maxWidth={false} style={{ marginTop: "10px" }}>
            <Grid item container md={12}>
                <Grid item md={12} >
                    <Typography color="primary" variant="h5">
                        PQ-Ereignisse Übersicht
                    </Typography>
                </Grid>
                <Grid item md={12} >
                    <Grid item md={12} style={{ textAlignLast: "right", marginTop: "-24px", marginBottom: "16px" }}>
                        <Button color="secondary"
                            onClick={() => setReload(!reload)}>Neu Laden<CachedIcon style={{ marginLeft: "10px" }} /></Button >
                    </Grid>
                </Grid>
                <Grid item md={12} >
                    <LegendeStoerung name={"pqEreignis"} />
                </Grid>
                <Grid item container md={12} spacing={2} className={classes.paddingPaper}>
                    <Grid item md={6}>
                        <Paper>
                            <Grid item container md={12}>
                                <Accordion style={{ width: "100%", marginBottom: "-3px" }}>
                                    <AccordionSummary>
                                        <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Status</Typography>
                                    </AccordionSummary>
                                </Accordion>
                            </Grid>
                            {pqStatusLoading ?
                                (
                                    <TableContainer className={classes.heightScrolledTableBottom}>
                                        <Table stickyHeader style={{ overflow: "hidden" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                )
                                : (
                                    <TableContainer >
                                        <Table stickyHeader size="small" style={{ marginBottom: "50px" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSubHighLight}></TableCell>
                                                <TableCell align="center" className={zeitraum === "24h" ? classes.highlightCell : classes.tableHeadlineSubHighLight} style={{ fontWeight: "600" }}>letzte 24 Stunden</TableCell>
                                                <TableCell align="center" className={zeitraum === "1M" ? classes.highlightCell : classes.tableHeadlineSubHighLight} style={{ fontWeight: "600" }}>letzte 30 Tage</TableCell>
                                                <TableCell align="center" className={zeitraum === "12M" ? classes.highlightCell : classes.tableHeadlineSubHighLight} style={{ fontWeight: "600" }}>letzte 12 Monate</TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {pqStatus.map((statusElement) => (
                                                    <TableRow key={statusElement.beschreibung} hover={true}>
                                                        <TableCell>{statusElement.beschreibung}</TableCell>
                                                        <TableCell align="center" className={zeitraum === "24h" ? classes.highlightCell : ""}>{getIconForStateValue(statusElement.status24h)}</TableCell>
                                                        <TableCell align="center" className={zeitraum === "1M" ? classes.highlightCell : ""}>{getIconForStateValue(statusElement.status1Month)}</TableCell>
                                                        <TableCell align="center" className={zeitraum === "12M" ? classes.highlightCell : ""}>{getIconForStateValue(statusElement.status12Month)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                        </Paper>
                    </Grid>
                    <Grid item md={6}>
                        <Paper className={classes.heightPaper} style={{ minWidth: "101%" }}>
                            <Grid item container md={12}>
                                <Accordion
                                    expanded={expandedMesspunkt}
                                    onChange={() => expandedMesspunkt ? setExpandedMesspunkt(false) : setExpandedMesspunkt(true)}
                                    style={{ width: "100%", marginBottom: "-3px" }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="messpunkt-content"
                                        id="messpunkt-header"
                                    >
                                        <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Messpunkte</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Autocomplete
                                            fullWidth
                                            id="select-zeitraum"
                                            defaultValue={zeitraumSelect.find(x => x.value === zeitraum)}
                                            onChange={(event, nV) => {
                                                onChangeZeitraum(nV != null ? (nV.value as string) : "")
                                            }}
                                            options={zeitraumSelect}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Zeitraum"
                                                    InputLabelProps={{ ...params.InputLabelProps }}
                                                    InputProps={{ ...params.InputProps }}
                                                    variant="outlined"
                                                />
                                            )}

                                            style={{ paddingRight: "5px", marginBottom: "35px" }}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            {pqMessstellenStatusLoading && messstellenLoadingLookup ?
                                (
                                    <TableContainer>
                                        <Table stickyHeader style={{ overflow: "hidden" }} >
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                )
                                : (
                                    <TableContainer className={expandedMesspunkt ? classes.heightScrolledTableTopExpanded : classes.heightScrolledTableTop}>
                                        <Table stickyHeader size="small" style={{ marginBottom: "50px" }} >
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Zustand</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Umspannwerk</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Schaltfeld</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Messpunkt</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Aktion</TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {getMessstellenForZeitraum(pqMessstellenStatus, zeitraum).map((messstelleStatus) => (
                                                    <TableRow selected={messstelleStatus.messstelle === selectedMessstelle} key={messstelleStatus.messstelle} hover={true}>
                                                        <TableCell>{getStateValueForZeitraum(messstelleStatus, zeitraum)}</TableCell>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, messstelleStatus.messstelle, "umspannwerk")}</TableCell>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, messstelleStatus.messstelle, "schaltfeld")}</TableCell>
                                                        <TableCell>{messstelleStatus.messstelle}</TableCell>
                                                        <TableCell><Button color="secondary" onClick={() => {
                                                            dispatch(getPQEreignisseForMessstelle(messstelleStatus, zeitraum));
                                                            setSelectedMessstelle(messstelleStatus.messstelle);
                                                            dispatch(getMesswertuebersicht(messstelleStatus, zeitraum));
                                                        }
                                                        }>zeige Ereignisse und Störschriebe</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                        </Paper>
                    </Grid>

                </Grid>
                <Grid item container xs={12} spacing={2} className={classes.paddingPaper}>

                    <Grid item xs={12} md={6} >
                        <Paper>
                            <Grid item container md={12}>
                                <Accordion
                                    expanded={expandedEreignis}
                                    onChange={() => expandedEreignis ? setExpandedEreignis(false) : setExpandedEreignis(true)}
                                    style={{ width: "100%", marginBottom: "-3px" }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="ereignis-content"
                                        id="ereignis-header"
                                    >
                                        <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Ereignisse</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Autocomplete
                                            fullWidth
                                            multiple
                                            limitTags={1}
                                            id="size-small-standard"
                                            noOptionsText={"Kein Ereignis"}
                                            value={ereignisseFilter}
                                            onChange={(_, newValue) => {
                                                dispatch(setEreignisseFilter(newValue));
                                            }}
                                            inputValue={pqmessstellenEreignisInputValue}
                                            onInputChange={(_, newInputValue) => {
                                                setpqmessstellenEreignisInputValue(newInputValue);
                                            }}
                                            options={getPQMesststellenListeWithoutDuplicate(pqMessstellenEreignisse)}
                                            getOptionLabel={(option) => option ? option : ""}
                                            disableCloseOnSelect
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    label="Ereignistyp"
                                                    InputLabelProps={{ ...params.InputLabelProps }}
                                                    InputProps={{ ...params.InputProps }}
                                                    variant="outlined"
                                                />
                                            }
                                            style={{ paddingRight: "5px", marginBottom: "35px" }}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            {pqMessstellenEreignisseLoading ?
                                (
                                    <TableContainer>
                                        <Table stickyHeader >
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                )
                                : (
                                    <TableContainer className={expandedEreignis ? classes.heightScrolledTableTopExpanded : classes.heightScrolledTableTop}>
                                        <Table stickyHeader size="small" style={{ marginBottom: "50px" }} >
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Ereignis</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Start</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Ende</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Aktion</TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {selectedMessstelle != "" && pqMessstellenEreignisse.length > 0 ? pqMessstellenEreignisse.filter(x => ereignisseFilter.length > 0 ? ereignisseFilter.includes(x.beschreibung + " " + x.typ + " " + x.harmonische) : true).map((ereignis, i) => (
                                                    <TableRow key={i} hover={true}>
                                                        {/* <TableCell>{getIconForStateValue(ereignis.zustand)}</TableCell> */}
                                                        <TableCell>{ereignis.beschreibung} {ereignis.phase} {ereignis.harmonische}</TableCell>
                                                        <TableCell>{isUTC ? nanosecondsTimeStampToUTCString(ereignis.zeit) : nanosecondsTimeStampToLocalString(ereignis.zeit)}</TableCell>
                                                        <TableCell>{isUTC ? nanosecondsTimeStampToUTCString(ereignis.ende) : nanosecondsTimeStampToLocalString(ereignis.ende)}</TableCell>
                                                        <TableCell>
                                                            <IconButton
                                                                color="secondary"
                                                                style={{ fontSize: "medium" }}
                                                                onClick={() => linkToDetails(ereignis.beschreibung, ereignis.messstelle, ereignis.zeit, ereignis.ende)}
                                                            >zur Detailansicht
                                                                <KeyboardArrowRight />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )) : keineGruppeTableCell(pqMessstellenEreignisse.length <= 0 ? "Keine Ereignisse" : "Keine Gruppe ausgewählt")
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6} >
                        <Paper style={{ minWidth: "101%" }}>
                            <Grid item container md={12}>
                                <Accordion
                                    expanded={expandedStoerschrieb}
                                    onChange={() => expandedStoerschrieb ? setExpandedStoerschrieb(false) : setExpandedStoerschrieb(true)}
                                    style={{ width: "100%", marginBottom: "-3px" }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="ereignis-content"
                                        id="ereignis-header"
                                    >
                                        <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Störschriebe</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Autocomplete
                                            fullWidth
                                            multiple
                                            id="size-small-standard"
                                            noOptionsText={"Kein Störschrieb"}
                                            value={stoerschriebeFilter}
                                            onChange={(_, newValue) => {
                                                dispatch(setStoerschriebeFilter(newValue));
                                            }}
                                            inputValue={pqmessstellenStoerschriebInputValue}
                                            onInputChange={(_, newInputValue) => {
                                                setpqmessstellenStoerschriebInputValue(newInputValue);
                                            }}
                                            options={getStoerschriebeListeWithoutDuplicate(stoerschriebeEreignisse)}
                                            getOptionLabel={(option) => option ? option : ""}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    label="Störschrieb"
                                                    InputLabelProps={{ ...params.InputLabelProps }}
                                                    InputProps={{ ...params.InputProps }}
                                                    variant="outlined"
                                                />
                                            }
                                            style={{ paddingRight: "5px", marginBottom: "35px" }}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            {stoerschriebeEreignisseLoading ?
                                (
                                    <TableContainer className={classes.heightScrolledTableBottom}>
                                        <Table stickyHeader style={{ overflow: "hidden" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                )
                                : (
                                    <TableContainer className={expandedStoerschrieb ? classes.heightScrolledTableTopExpanded : classes.heightScrolledTableTop}>
                                        <Table stickyHeader size="small" style={{ marginBottom: "50px" }} >
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Störschrieb</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Start</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Ende</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Aktion</TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {selectedMessstelle != "" && stoerschriebeEreignisse.length > 0 ? stoerschriebeEreignisse.filter(x => stoerschriebeFilter.length > 0 ? stoerschriebeFilter.includes(x.datenklasse) : true).map((stoerschrieb, i) => (

                                                    <TableRow key={i} hover={true}>
                                                        <TableCell>{stoerschrieb.datenklasse}</TableCell>
                                                        <TableCell>{isUTC ? nanosecondsTimeStampToUTCString(stoerschrieb.start) : nanosecondsTimeStampToLocalString(stoerschrieb.start)}</TableCell>
                                                        <TableCell>{isUTC ? nanosecondsTimeStampToUTCString(stoerschrieb.ende) : nanosecondsTimeStampToLocalString(stoerschrieb.ende)}</TableCell>
                                                        <TableCell>
                                                            <IconButton
                                                                color="secondary"
                                                                style={{ fontSize: "medium" }}
                                                                onClick={() => linkToDetails(stoerschrieb.datenklasse, stoerschrieb.messstelle, stoerschrieb.start, stoerschrieb.ende, true)}
                                                            >zur Detailansicht
                                                                <KeyboardArrowRight />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )) : keineGruppeTableCell(stoerschriebeEreignisse.length <= 0 ? "Keine Störschriebe" : "Keine Gruppe ausgewählt")
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                        </Paper>
                    </Grid>

                </Grid>
            </Grid>
        </Container >
    )
}
